import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconBellOff(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.034 2.514a.666.666 0 1 1-.655-1.161A5.334 5.334 0 0 1 13.334 6v2.667a.667.667 0 1 1-1.334 0V6a4.001 4.001 0 0 0-5.966-3.486zM11.057 12H1.333c-.889 0-.889-1.333 0-1.333.736 0 1.333-.597 1.333-1.333V6.002a5.318 5.318 0 0 1 .388-2.003L.195 1.14a.668.668 0 0 1 .943-.943l3.176 3.176.022.022 11.469 11.469a.668.668 0 0 1-.943.943zM4.112 5.055A4.05 4.05 0 0 0 4 6v3.333c0 .486-.13.941-.357 1.333h6.081zm4.465 8.61a.667.667 0 0 1 1.153.669 2 2 0 0 1-3.46 0 .667.667 0 0 1 1.153-.669.666.666 0 0 0 1.154 0z"
  }));
}
IconBellOff.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconBellOff.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconBellOff as default };
